import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import { LabelFilters } from "./components/LabelFilters";
import {
  LabelSearchRequestProvider,
  LabelTable,
} from "./components/LabelTable";

export function LabelsPage() {
  return (
    <TablePage
      title="Search Labels"
      navigation={<LqsNavigation />}
      RequestProvider={LabelSearchRequestProvider}
      table={<LabelTable />}
      filters={<LabelFilters />}
    />
  );
}
